import { BookingLocalModule } from '@modules/booking/booking-local.module';
import { VirtualIdLocalModule } from '@modules/virtual-id/virtual-id-local.module';
import { DocumentsLocalModule } from '@modules/documents/documents-local.module';
import { ClubLocalModule } from '@modules/application/application';
import { InscriptionLocalModule } from '@modules/academy/academy-local.module';
import { PollLocalModule, SigningLocalModule } from '@modules/polling/polling-local.module';
// import MeetingModuleInfo from './modules/meeting/meeting-local.module';
import { RecurringPaymentLocalModule } from '@modules/recurring-payments/recurring-payments-local.module';
import { MemberStateLocalModule } from '@modules/member-state/member-state-local.module';
import { MemberInformationLocalModule } from '@modules/member-information-update/member-information-update-local.module';
import { AccountSettingsLocalModule } from '@modules/account-settings/account-settings-local.module';

export const FIXED_LOCAL_MODULES: ClubLocalModule[] = [
    {
        code: '2bbb3b3fcc50ad33bfb39f2c068fbbae',
        localEnabled: true,
        includeInNavigation: true,
        name: 'Inicio',
        url: '/',
    },
];

export const LOCAL_MODULES: ClubLocalModule[] = [
    BookingLocalModule,
    InscriptionLocalModule,
    VirtualIdLocalModule,
    DocumentsLocalModule,
    PollLocalModule,
    SigningLocalModule,
    RecurringPaymentLocalModule,
    MemberStateLocalModule,
    MemberInformationLocalModule,
    AccountSettingsLocalModule,
];
